
//更新用户信息
export const UPDATE_USERINFO = 'UPDATE_USERINFO';

//更新学校用户的信息
export const UPDATE_TOKEN = 'UPDATE_TOKEN';

//清空用户信息
export const REMOVE_USERINFO = 'REMOVE_USERINFO';

//设置用户身份
export const UPDATE_IDENTITY = 'UPDATE_IDENTITY';

//设置当前选中菜单
export const UPDATE_SELECTEDMENU ='UPDATE_SELECTEDMENU'

//默认密码修改标志
export const UPDATE_USERPWDFLAG = 'UPDATE_USERPWDFLAG'

//修改默认租户
export const UPDATE_TENANT = 'UPDATE_TENANT'

